import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;

const jsona = new Jsona();

const PRICING_API = `${API_URL}/backoffice/pricings`;

async function getAll(params) {
  const response = await axios.get(PRICING_API, { params: params, headers: authHeader() });
  return response.data;
}

async function get(id) {
  const response = await axios.get(PRICING_API + '/' + id, { headers: authHeader() });
  return response.data;
}

async function create(params) {
  const response = await axios.post(PRICING_API, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function update(params, id) {
  const response = await axios.put(PRICING_API + "/" + id, params, { headers: authHeader() });
  return jsona.deserialize(response.data);
}

async function deleteAction(id) {
  const response = await axios.delete(PRICING_API + '/' + id, { headers: authHeader() });
  return response.data;
}

export default {
  getAll,
  update,
  create,
  get,
  delete: deleteAction,
};